import IntegromatIntegration from './IntegromatIntegration';
export default IntegromatIntegration;
